<template>
  <section>
    <div v-if="loading">
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
            <a data-target="#socialreason" data-toggle="modal" class="button text-white bg-theme-1 shadow-md mr-2">Crear Razon Social</a>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- Edit -->
      <div class="intro-y box mt-6" v-if="boxedit">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
            Editar Cuenta
          </h2>
        </div>
        <form @submit.prevent="updateEditSocialReason">
        <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
          <div class="col-span-12 sm:col-span-12">
            <label>Nombre</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason_current.name" required>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Moneda</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason_current.money" required>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Codigo de Moneda</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason_current.money_code" required>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Prefijo de Moneda Ej: (USD, $, P/)</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason_current.money_prefix" required>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Formato de moneda Ej: (1,000.00)</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason_current.money_format" required>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Prefijo de impuesto Ej: (IVA, IGV)</label>
            <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason_current.tax_prefix" required>
          </div>
          <div class="col-span-12 sm:col-span-12">
            <label>Pais</label>
            <select class="input w-full border mt-2 flex-1" v-model="socialreason_current.country_id" required>
              <option seleted :value="null">Seleccione el país</option>
              <option v-for="country in countries" :value="country.id" :key="`country-${country.id}`">
                {{country.name}}
              </option>
            </select>
          </div>
        </div>
        <div class="px-5 py-3 text-right border-t border-gray-200">
            <button type="button" @click="closeEditSocialReason()" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
            <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Modificar</button>
        </div>
        </form>
      </div>
      <!-- END: Edit -->

      <!-- List -->
      <div class="overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="whitespace-no-wrap">NOMBRE</th>
              <th class="text-center whitespace-no-wrap">PAIS</th>
              <th class="text-center whitespace-no-wrap">MONEDA</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr class="intro-x" v-for="socialreason in socialreasons" :key="`social-reason-${socialreason.id}`">
              <td>
                <a href="#" class="font-medium whitespace-no-wrap">{{socialreason.name}}</a>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">{{socialreason.country_name}}</div>
              </td>
              <td>
                <div class="text-gray-600 text-xs whitespace-no-wrap text-center">{{socialreason.money}}</div>
              </td>
              <td class="table-report__action w-56">
                  <div class="flex justify-center items-center flex-wrap">
                      <button @click="editSocialReason(socialreason)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                        <app-icon name="edit" classname="w-4 h-4 mr-2" /> Editar
                      </button>
                      <button v-if="!socialreason.usd_convertion" @click="trmChange(socialreason)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                        <app-icon name="edit" classname="w-4 h-4 mr-2" /> Actualizar Trm
                      </button>
                      <button v-if="socialreason.trm_change.length" @click="trmChangeHistory(socialreason)" class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md">
                        <app-icon name="edit" classname="w-4 h-4 mr-2" /> Ver Historial Trm
                      </button>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: List -->
    </div>

    <app-loading v-else></app-loading>

    <!-- Modal -->
    <div class="modal" id="socialreason">
      <div class="modal__content modal__content--sm">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              Crear Razon Social
          </h2>
        </div>
        <form @submit.prevent="createSocialReason" enctype="multipart/form-data" class="form-task">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
              <label>Nombre</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason.name" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Moneda</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason.money" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Codigo de Moneda</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason.money_code" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Prefijo de Moneda Ej: (USD, $, P/)</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason.money_prefix" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Formato de moneda Ej: (1,000.00)</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason.money_format" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
              <label>Prefijo de impuesto Ej: (IVA, IGV)</label>
              <input type="text" class="input w-full border mt-2 flex-1" v-model="socialreason.tax_prefix" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Pais</label>
                <select class="input w-full border mt-2 flex-1" v-model="socialreason.country_id" required>
                  <option seleted value="null">Seleccione el país</option>
                  <option v-for="country in countries" :value="country.id" :key="`country-${country.id}`">
                    {{country.name}}
                  </option>
              </select>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
              <button type="button" data-dismiss="modal" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
              <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Crear</button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal End -->

    <TrmChangeHistoryModal :socialreason="socialreason_current" v-if="boxtrmchangehistory" @closeModal="closeTrmChangeHistoryModal()" />
    <TrmChangeModal :socialreason="socialreason_current" v-if="boxtrmchange" @closeModal="closeTrmChangeModal()" />
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Icon from '@/components/admin/partials/Icon'
  import Loading from '@/components/admin/partials/LoadingWhite'
  import TrmChangeModal from '@/components/admin/social-reasons/TrmChangeModal'
  import TrmChangeHistoryModal from '@/components/admin/social-reasons/TrmChangeHistoryModal'

  export default {
    name: 'AdminListTask',
    data () {
      return {
        loading: false,
        boxedit: false,
        boxtrmchange: false,
        boxtrmchangehistory: false,
        socialreason: this.defineSocialReason(),
        socialreason_current: {}
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
        socialreasons: 'getSocialReasons',
        countries: 'getAccountCountries'
      }),
    },
    mounted() {
      $('#socialreason').on('hidden.bs.modal', () => { this.defineSocialReason() })
    },
    async beforeMount () {
      try {
        await this.getAll('socialreason')
        await this.getList('accountcountry')

        this.loading = true
      } catch (error) {}
    },
    methods: {
      defineSocialReason() {
        return {
          name: null,
          money: null,
          money_code: null,
          country_id: null,
          entity: 'socialreason',
          money_prefix: null,
          money_format: '1,000.00',
          tax_prefix: 'IVA',
        }
      },
      createSocialReason() {
        var vm = this
        window.$('#create').button('loading')
        vm.store(vm.socialreason).then(item => {
          window.$('#socialreason').modal('hide')
          vm.$router.replace(vm.$route.query.redirect || '/admin/business/social-reasons')
        })
        .catch(error => {
          console.log('FAILURE!!');
        })
        .finally(() => {
          window.$('#create').button('reset')
          vm.loading = true
          this.socialreason = this.defineSocialReason()
        });
      },
      editSocialReason(value) {
        this.boxedit = true
        this.socialreason_current = JSON.parse(JSON.stringify(value))
      },
      trmChange(value) {
        this.boxtrmchange = true
        this.socialreason_current = JSON.parse(JSON.stringify(value))
      },
      closeTrmChangeModal() {
        this.boxtrmchange = false
        this.socialreason_current = {}
      },
      trmChangeHistory(value) {
        this.boxtrmchangehistory = true
        this.socialreason_current = JSON.parse(JSON.stringify(value))
      },
      closeTrmChangeHistoryModal() {
        this.boxtrmchangehistory = false
        this.socialreason_current = {}
      },
      closeEditSocialReason() {
        this.boxedit = false
        this.socialreason_current = {}
      },
      updateEditSocialReason(value) {
        let vm = this
        vm.socialreason_current.entity = 'socialreason';
        vm.loading = false
        vm.update(vm.socialreason_current).then(item => {
          vm.loading = true
          vm.boxedit = false
          vm.socialreason = this.defineSocialReason()
          vm.$router.replace(vm.$route.query.redirect || '/admin/business/social-reasons')
        })
        .catch(message => {
          vm.loading = true
        })
      },
      ...mapActions([
        'getAll',
        'getList',
        'store',
        'update'
      ])
    },
    components: {
      appIcon: Icon,
      appLoading: Loading,
      TrmChangeModal,
      TrmChangeHistoryModal
    },
  }
</script>



// WEBPACK FOOTER //
// ListSocialReasons.vue?3417f4a4